import gql from 'graphql-tag';

const query = gql`
  query CookbookCategories {
    cookbook {
      categories {
        id
        type
        position
        name
        description
        ... on DietTypesSliderCookbookCategory {
          tags {
            id
            name
            imageUrl
            mealsCount
          }
        }
        ... on SliderCookbookCategory {
          meals(first: 6) {
            edges {
              node {
                id
                name
                isFavorite
                preparationImageUrl
                preparationTime {
                  minutes
                }
                nutrition {
                  singleServing {
                    kcal
                  }
                }
                tags {
                  dietTypeTags {
                    id
                    name
                  }
                  mealTypeTags {
                    id
                    name
                  }
                  customTags {
                    id
                    name
                    labelColor
                  }
                }
                rating {
                  averageRating {
                    averageRating
                  }
                }
              }
            }
          }
          tagsVisibility {
            dietTypeTagsVisibleOnHomepage
            mealTypeTagsVisibleOnHomepage
            customTagsVisibleOnHomepage
          }
        }
        ... on ListCookbookCategory {
          meals(first: 6) {
            edges {
              node {
                id
                name
                isFavorite
                preparationImageUrl
                preparationTime {
                  minutes
                }
                nutrition {
                  singleServing {
                    kcal
                  }
                }
                tags {
                  dietTypeTags {
                    id
                    name
                  }
                  mealTypeTags {
                    id
                    name
                  }
                  customTags {
                    id
                    name
                    labelColor
                  }
                }
                rating {
                  averageRating {
                    averageRating
                  }
                }
              }
            }
          }
          tagsVisibility {
            dietTypeTagsVisibleOnHomepage
            mealTypeTagsVisibleOnHomepage
            customTagsVisibleOnHomepage
          }
        }
      }
    }
  }
`;

export default query;
